module.exports = fox._r("images/slides/urban/slide_3_4.jpg", __webpack_public_path__ + "images/slides/urban/slide_3_4.jpg");


//////////////////
// WEBPACK FOOTER
// ./images/slides/urban/slide_3_4.jpg
// module id = 63
// module chunks = 2